
import { postTags } from '../api/postTags';
import { putTags } from '../api/putTags';
import { setGetTags } from './setGetTags';

export const setPostTags = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await postTags(params);

            dispatch(setGetTags({user_id: params.user_id}));
            alert('сохранен')
            if (callback) {
                callback()
            }
        } catch (error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}